<template>
  <el-dialog
    :model-value="flagVisible" width="55%"
    :before-close="handleClose"
  >
  <div class="search">
    <el-input
      class="searchInput"
      placeholder="Search"
      v-model="filter.name"
       @input="changeFilter"
    >
      <template #prefix>
        <i class="el-icon-search"></i>
      </template>
    </el-input>
    <button class="addButton" @click="saveOtherProducts">done</button>
  </div>
  <div class="productsList">
      <el-row :gutter="15">
        <el-col :span="24">
            <div class="main-table">
              <el-table
                class="productsTable"
                :data="selectedProducts"
                size="small"
                :header-cell-style="headerStyle"
                :cell-style="cellStyle"
                v-loading="flagLoading.changeProducts"
              >
                <el-table-column label="Selected Products">
                <el-table-column label="Price">
                  <template #default="scope">
                    {{ `${scope.row.price.default.currency}${scope.row.price.default.price}` }}
                  </template>
                  </el-table-column>
                  <el-table-column prop="general.brand_name" label="Brand"></el-table-column>
                  <el-table-column prop="general.name" label="Name"></el-table-column>
                  <el-table-column label="Operate">
                    <template #default="scope">
                      <el-popconfirm
                        title="Confirm to delete this product?"
                        @confirm="cancelSelected(scope.row, scope.$index)"
                      >
                        <template #reference>
                          <el-button size="small" type="text" class="el-btn-blue">Delete</el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
        </el-col>
      </el-row>
  </div>
  <div class="productsList">
    <el-row :gutter="15">
      <el-col :span="24">
          <div class="main-table">
              <el-table
                class="productsTable"
                :data="productsList"
                size="small"
                :header-cell-style="headerStyle"
                :cell-style="cellStyle"
                v-loading="flagLoading.getProducts"
              >
                <el-table-column :label="addFromWhere === 'mine' ? 'Products from my brand' : 'Products from other brands'">
                  <el-table-column label="Price">
                    <template #default="scope">
                      {{ `${scope.row.price.default.currency}${scope.row.price.default.price}` }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="general.brand_name" label="Brand"></el-table-column>
                  <el-table-column prop="general.name" label="Name"></el-table-column>
                  <el-table-column label="Add">
                    <template #default="scope">
                      <el-switch v-model="scope.row.is_active" @change="selected(scope.row, scope.$index)" active-color="#A5C2CB" />
                    </template>
                  </el-table-column>
                </el-table-column>
            </el-table>
            <el-pagination
              class="common-pagination" background layout="prev, pager, next"
              :current-page="pageNum" :page-size="pageSize" :total="totalNum"
              @current-change="changeCurrentPage"
            />
          </div>
      </el-col>
    </el-row>
  </div>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    role: String,
    brandId: String,
    addFromWhere: String,
    flagVisible: Boolean
  },
  data () {
    const filter = reactive({
      name: ''
    })
    const flagLoading = reactive({
      getProducts: false,
      changeProducts: false
    })
    return {
      search: '',
      productsList: [],
      selectedProducts: [],
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      filter,
      flagLoading
    }
  },
  emits: ['closeModal', 'updateData', 'changeProducts'],
  created: function () {
    // this.getProducts()
  },
  watch: {
    flagVisible: {
      handler: function (val) {
        this.selectedProducts = []
        this.getProducts()
      },
      deep: true
    }
  },
  methods: {
    getProducts: function () {
      this.flagLoading.getProducts = true
      const { pageNum, pageSize, filter } = this
      let url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/products?page_num=${pageNum}&page_size=${pageSize}`
      if (this.addFromWhere === 'others') {
        url += '&all_brand=1'
      } else if (this.addFromWhere === 'mine' && this.role === 'admin') {
        url += `&brand_id=${this.brandId}`
      }
      if (filter.name) url += `&name=${filter.name}`
      const that = this
      const body = { all_brand: 1 }
      this.$service.get(url, body).then(function (res) {
        if (res.code === 200) {
          that.productsList = res.data.list
          that.productsList.map((item) => {
            const index = that.selectedProducts.findIndex(selectedItem => selectedItem._id === item._id)
            if (index !== -1) {
              item.is_active = true
            }
          })
          that.totalNum = res.data.total_num
        }
        that.flagLoading.getProducts = false
      }).catch(function (err) {
        console.error('getProducts', err)
        that.flagLoading.getProducts = false
      })
    },
    headerStyle: function () {
      return 'border-width:0;background:#DBE7EA;font-weight:bold;font-size:16px;height:0px;'
    },
    cellStyle: function () {
      return 'border-width:1px 0;'
    },
    changeCurrentPage: function (page) {
      this.pageNum = page
      this.getProducts()
    },
    handleClose: function () {
      this.$emit('closeModal')
    },
    changeFilter: function () {
      this.pageNum = 1
      this.getProducts()
    },
    selected: function (target, index) {
      this.flagLoading.changeProducts = true
      if (this.productsList[index].is_active) {
        if (this.selectedProducts.findIndex(item => item._id === this.productsList[index]._id) === -1) {
          this.selectedProducts.push(this.productsList[index])
          this.flagLoading.changeProducts = false
        }
      } else {
        this.selectedProducts.splice(this.selectedProducts.findIndex(item => item._id === this.productsList[index]._id), 1)
        this.flagLoading.changeProducts = false
      }
    },
    cancelSelected: function (target, index) {
      this.flagLoading.changeProducts = true
      this.productsList.map((item) => {
        if (item._id === this.selectedProducts[index]._id) {
          item.is_active = false
        }
      })
      this.selectedProducts.splice(index, 1)
      this.flagLoading.changeProducts = false
    },
    saveOtherProducts: function () {
      this.$emit('changeProducts', { array: this.selectedProducts, tab: this.addFromWhere })
      this.productsList.map((item) => {
        if (item.is_active) {
          item.is_active = false
        }
      })
      this.selectedProducts = []
      this.$emit('closeModal')
    }
  }
}
</script>
<style scoped lang="scss">
.search {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  /deep/.el-input__inner {
    background: #DBE7EA;
    border-radius: 6px;
    width: 60%;
    &::placeholder {
      color: #3B4D5D;
    }
  }
  .addButton {
    width: 10%;
    background: #A5C2CB;
    border-radius: 6px;
    border: 0px;
    cursor: pointer;
  }
}
.productsList{
  padding-bottom: 10px;
  .main-table {
    /deep/.el-table__header-wrapper {
      border-radius: 8px;
    }
    /deep/.el-table--border, .el-table--group {
      border: none;
      &::after {
        width: 0px;
      }
    }
  }
}
</style>
